import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';
import { websiteImages } from '../config/images';
import { Facebook, Instagram, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <footer className="bg-black border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Logo & Tagline */}
          <div>
            <img 
              src={websiteImages.logo.url} 
              alt={websiteImages.logo.alt}
              className="h-16 w-auto mb-4"
            />
            <p className="text-white/70 text-sm">
              {t.footer_tagline}
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">{t.contact_title}</h3>
            <div className="space-y-3 text-white/70 text-sm">
              <div className="flex items-start gap-2">
                <MapPin className="w-4 h-4 text-[#d4af37] flex-shrink-0 mt-1" />
                <div>
                  <p>Kaiser-Friedrich-Straße 49</p>
                  <p>10627 Berlin, Charlottenburg</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-[#d4af37] flex-shrink-0" />
                <a href="tel:+493089542916" className="hover:text-[#d4af37] transition-colors duration-200">
                  +49 30 8954 2916
                </a>
              </div>
              <p className="text-[#d4af37] font-semibold">{t.hours_value}</p>
            </div>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">{t.footer_follow}</h3>
            <div className="flex items-center gap-4">
              <a 
                href="https://www.facebook.com/corbaciberlin/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center text-white hover:bg-[#d4af37] hover:text-black transition-all duration-300 transform hover:scale-110"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="https://www.instagram.com/corbaciberlin/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center text-white hover:bg-[#d4af37] hover:text-black transition-all duration-300 transform hover:scale-110"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href="https://www.tiktok.com/@corbaciberlin?_r=1&_t=ZG-997dD8C2hnc" 
                target="_blank" 
                rel="noopener noreferrer" 
                aria-label="TikTok"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center text-white hover:bg-[#d4af37] hover:text-black transition-all duration-300 transform hover:scale-110"
              >
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M16.5 3c.3 2.1 1.6 3.9 3.5 4.5v3c-1.4 0-2.7-.4-3.9-1.1v6.1c0 3.2-2.6 5.8-5.8 5.8S4.5 18.7 4.5 15.5 7.1 9.7 10.3 9.7c.3 0 .6 0 .9.1v3.1c-.3-.1-.6-.2-.9-.2-1.5 0-2.7 1.2-2.7 2.7s1.2 2.7 2.7 2.7 2.7-1.2 2.7-2.7V3h3z"/></svg>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-white/60 text-sm">
            <div className="flex flex-col md:flex-row items-center gap-2 md:gap-4">
              <p>© {new Date().getFullYear()} Corbaci. {t.footer_rights}</p>
              <span className="hidden md:inline">|</span>
              <a 
                href="https://alka.website" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-white/50 hover:text-[#d4af37] transition-colors duration-200 flex items-center gap-1"
              >
                Designed by <span className="font-semibold">Alka</span>
              </a>
            </div>
            <div className="flex items-center gap-4">
              <a href="https://order.site/cobarci/tr/deu/berlin/restaurant/corbaci-sf?no_universal_links=true" target="_blank" rel="noopener noreferrer" className="hover:text-[#d4af37] transition-colors duration-200">Wolt</a>
              <span>|</span>
              <a href="https://www.ubereats.com/de/store/corbaci-authentische-turkische-kuche/Z4L9pQSxVnyHd6TEiOAjOQ" target="_blank" rel="noopener noreferrer" className="hover:text-[#d4af37] transition-colors duration-200">Uber Eats</a>
              <span>|</span>
              <a href="https://www.lieferando.de/speisekarte/corbaci-10627" target="_blank" rel="noopener noreferrer" className="hover:text-[#d4af37] transition-colors duration-200">Lieferando</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
